/* eslint-disable import/prefer-default-export */
import { set as _set, delay as _delay, groupBy as _groupBy, mapValues as _mapValues, keyBy as _keyBy } from 'lodash';

export const set = _set;
export const delay = _delay;
export const groupBy = _groupBy;
export const mapValues = _mapValues;
export const keyBy = _keyBy;

interface RemoveUndefinedValuesOptions {
  shouldRemoveBlankStrings?: boolean;
}

export function removeUndefinedValues<T extends Object>(
  data: T,
  { shouldRemoveBlankStrings }: RemoveUndefinedValuesOptions = { shouldRemoveBlankStrings: true }
): Partial<T> {
  const result: Partial<T> = {};

  Object.keys(data).forEach((key) => {
    const value =
      shouldRemoveBlankStrings &&
      typeof data[key as keyof T] === 'string' &&
      (data[key as keyof T] as unknown as string).length === 0
        ? undefined
        : data[key as keyof T];

    if (value !== null && value !== undefined) {
      result[key as keyof T] = value;
    }
  });

  return result;
}

export function checkEmptyObject<T extends Object>(obj?: T | null): T | null | undefined {
  const data = obj ? removeUndefinedValues(obj, { shouldRemoveBlankStrings: true }) : obj;
  const isEmptyObject = data && typeof data === 'object' && Object.keys(data).length === 0;
  return isEmptyObject ? null : obj;
}
